import React from 'react'

class AccidentModalQuotes extends React.PureComponent {
  render() {
    return (
      <div>
        <p>
          We use Audatex, the industry standard estimating system, to make sure
          you get the best quote. It calculates repair times and transfers the
          relevant part data to comprise a quote. This is a completely
          transparent process and you will be consulted throughout.
        </p>
      </div>
    )
  }
}

export default AccidentModalQuotes
